<div class="top-bg border-bottom" role="banner">
    <div class="container ">

      <mat-toolbar class="h-100 p-0">
      <div class="top-nav-content">
        <div class="logo-contents">
        <div class="logo" [hidden]="llttfPage">
            <img src="assets/u299.png" alt="BB Logo" />
        </div>
        <div class="logo" [hidden]="!llttfPage">
          <img src="assets/llttflogo.png" alt="LLTTF Logo" />
      </div>

   </div>
   </div>
      </mat-toolbar>
    </div>
  </div>
